"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sprite = exports.createSprite = exports.useSprite = exports.SpriteContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var PIXI = _interopRequireWildcard(require("pixi.js"));

var _Container = require("../Container");

var _hooks = require("../hooks");

var _View = require("../UI/View");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SpriteContext = (0, _react.createContext)(undefined);
exports.SpriteContext = SpriteContext;
SpriteContext.displayName = 'Sprite';

var useSprite = function useSprite() {
  return (0, _react.useContext)(SpriteContext);
}; // should only usage in `Sprite` package, DO NOT export to others.


exports.useSprite = useSprite;

var createSprite = function createSprite(displayName, supplier, update) {
  var Sprite = function Sprite(props, ref) {
    var container = (0, _Container.useContainer)();
    var sprite = (0, _hooks.useCloseable)(function () {
      var sprite = supplier(props);
      container.addChild(sprite);
      (0, _View.setRef)(ref, sprite);
      return sprite;
    }, function (sprite) {
      (0, _View.setRef)(ref, null);
      container.removeChild(sprite);
      sprite.destroy();
    });
    update(sprite, props);
    var children = props.children,
        texture = props.texture,
        position = props.position,
        scale = props.scale,
        _props$anchor = props.anchor,
        anchor = _props$anchor === void 0 ? {
      x: 0.5,
      y: 0.5
    } : _props$anchor,
        rotation = props.rotation,
        _props$tint = props.tint,
        tint = _props$tint === void 0 ? 0xFFFFFF : _props$tint,
        blendMode = props.blendMode;
    if (texture != null && texture !== sprite.texture) sprite.texture = texture;
    if (position && position !== sprite.position) sprite.position.set(position.x, position.y);

    if (scale != null) {
      var _ref = scale instanceof Object ? scale : {
        x: scale,
        y: scale
      },
          x = _ref.x,
          y = _ref.y;

      if (x !== sprite.scale.x) sprite.scale.x = x;
      if (y !== sprite.scale.y) sprite.scale.y = y;
    }

    if (anchor) {
      if (anchor.x !== sprite.anchor.x) sprite.anchor.x = anchor.x;
      if (anchor.y !== sprite.anchor.y) sprite.anchor.y = anchor.y;
    }

    if (rotation) {
      if ('degree' in rotation && rotation.degree !== sprite.angle) sprite.angle = rotation.degree;else if ('radian' in rotation && rotation.radian !== sprite.rotation) sprite.rotation = rotation.radian;
    }

    if (tint !== sprite.tint) sprite.tint = tint;
    if (blendMode != null && blendMode !== sprite.blendMode) sprite.blendMode = blendMode;
    return _react.default.createElement(SpriteContext.Provider, {
      value: sprite
    }, children);
  };

  Sprite.displayName = displayName;
  return (0, _react.forwardRef)(Sprite);
};

exports.createSprite = createSprite;
var Sprite = createSprite('Sprite', function (_ref2) {
  var texture = _ref2.texture;
  return new PIXI.Sprite(texture);
}, function (_sprite, _props) {});
exports.Sprite = Sprite;